const PROFILE_LOG_CLASS_NAME = 'ProfileLog'

const PROFILE_LOG_KEY = {

  ID: 'id',
  CLASS_NAME: 'className',
  CREATED_AT: 'createdAt',
  UPDATED_AT: 'updatedAt',

  TYPE: 'type',
  VALUE: 'value',

  MEDIA: 'media',

  // Associations
  PROFILE_ID: 'profileId',
  MEDIA_ID: 'mediaId'
}

const PROFILE_LOG_TYPE = {
  WEIGHT: 1
}

const PROFILE_LOG_PRIVATE_KEYS = []

const PROFILE_LOG_FITNESS_DATA_KEYS = []

const PROFILE_LOG_SCOPE = {

  /**
   * Only returns the public attributes of a `Settings`.
   * @type {Object}
   */
  defaultScope: {
    attributes: {
      exclude: PROFILE_LOG_PRIVATE_KEYS
    }
  }

}

const PROFILE_LOG_AUDIT = {
  CREATED: 'ProfileLog Created',
  DELETED: 'ProfileLog Deleted',
  UPDATED: 'ProfileLog Updated'
}

export {
  PROFILE_LOG_CLASS_NAME,
  PROFILE_LOG_KEY,
  PROFILE_LOG_PRIVATE_KEYS,
  PROFILE_LOG_FITNESS_DATA_KEYS,
  PROFILE_LOG_AUDIT,
  PROFILE_LOG_SCOPE,
  PROFILE_LOG_TYPE
}

export const PROFILE_LOG_ASSOCIATIONS = [
  PROFILE_LOG_KEY.MEDIA
]
